import { Component, ElementRef, Input } from '@angular/core';
import 'moment/locale/id';
import { BatteryRentRestService } from '../battery-rent-rest.service';
import Swal from 'sweetalert2';
import { APP_CONST } from '../../../app.const';
import { BatteryRentListComponent } from '../list/battery-rent-list.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-detail-modal',
  templateUrl: 'detail-modal.component.html',
  styleUrls: ['../list/battery-rent-list.component.scss']
})
export class DetailModalComponent {
  @Input() initialCustomerData: any;
  isModalOpen: boolean = false;
  nikInput: string = ''; // To hold user input for NIK
  customerData: any = null; // To store fetched customer data
  selectedCustomer: any = null;
  uploadEndpoint = APP_CONST.API_FILE;
  isCustomerLoading: boolean = false;
  selectedFile: any;
  photoPreviewTitle: string = '';
  isPhotoPreviewOpen: boolean = false;
  isEdit: boolean = false;

  onMotorcycleNumberChange(index: number) {
    this.selectedCustomer = this.customerData[index];
  }

  constructor(
    private _BatteryRentRest: BatteryRentRestService,

    public _batteryRentListComponent: BatteryRentListComponent
  ) {}

  async openModal() {
    this.isModalOpen = true;
    this.customerData = null; // Reset customer data when modal is opened
    this.nikInput = this.initialCustomerData.nik; // Clear NIK input
    this.initialCustomerData.pks = await this.renderPresignedUrl(this.initialCustomerData.pks);
    this.initialCustomerData.invoice = await this.renderPresignedUrl(this.initialCustomerData.invoice);
  }

  closeModal() {
    this.nikInput = '';
    this.isModalOpen = false;
  }

  openPhotoPreview(file, title: string) {
    this.selectedFile = file;
    this.photoPreviewTitle = title;
    this.isPhotoPreviewOpen = true;
  }

  isLoadingPresignedUrl: boolean = false;

  async renderPresignedUrl(file: any) {
    if (!file) return null;

    if (typeof file === 'string' && (file.startsWith('http://') || file.startsWith('https://'))) {
      return file; // Direct URL
    }

    this.isLoadingPresignedUrl = true;
    try {
      const payload = { storageFileName: file };
      const response = await this._BatteryRentRest.getPresignedUrl(payload).toPromise();
      this.isLoadingPresignedUrl = false;
      return response.url;
    } catch (error) {
      this.isLoadingPresignedUrl = false;
      console.error('Error fetching presigned URL:', error);
      return null;
    }
  }

  fetchCustomerData() {
    if (!this.nikInput) {
      Swal.fire('Error', 'Please enter a valid NIK.', 'error');
      return;
    }

    this.isCustomerLoading = true;
    this._BatteryRentRest.getCustomer({ nik: this.nikInput }).subscribe({
      next: response => {
        if (response.data.data.length > 0) {
          this.customerData = response.data.data;
          Swal.fire('Success', 'Data pelanggan ditemukan.', 'success');
        } else {
          Swal.fire('Error', 'Data pelanggan tidak ditemukan.', 'error');
        }
        this.isCustomerLoading = false;
      },
      error: err => {
        console.error('Error fetching customer data:', err);
        Swal.fire('Error', 'Data pelanggan tidak ditemukan.', 'error');
        this.isCustomerLoading = false;
      }
    });
  }

  generatePayload() {
    const payload = {
      customerName: this.initialCustomerData.customerName,
      chassisNumber: this.initialCustomerData.chassisNumber,
      customerPhone: this.initialCustomerData.customerPhone,
      customerAddress: this.initialCustomerData.customerAddress
      // Add any other fields you want to include in the payload
    };

    // Validate if any payload value is empty or undefined
    for (const [key, value] of Object.entries(payload)) {
      if (!value) {
        Swal.fire('Error', `Field "${key}" cannot be empty.`, 'error');
        return null;
      }
    }

    return payload;
  }

  onImageFinishUploaded(image, inputName: string) {
    this.selectedCustomer[inputName] = image?.fileUrl;
  }

  // Method to handle the submit action
  isSubmitting: boolean = false;

  submitForm() {
    const payload = this.generatePayload();

    if (!payload) {
      // Payload generation failed, likely due to no selection
      return;
    }

    this.isSubmitting = true;
    console.log('Submitting form with payload:', payload);

    this._BatteryRentRest.update(payload, this.initialCustomerData._id).subscribe({
      next: response => {
        Swal.fire('Success', 'Battery rent update successful!', 'success');
        this._batteryRentListComponent.callHookDirectly('init');
        this.closeModal(); // Close modal on success
        this.isSubmitting = false;
      },
      error: err => {
        console.error('Error submitting form:', err);
        Swal.fire('Error', 'Failed to update battery rent. Please try again.', 'error');
        this.isSubmitting = false;
      }
    });
  }
}
